import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex gap-x-4 relative p-4 font-montserrat",
  style: {"max-height":"calc(55vh / var(--viewport-scale)) !important"}
}
const _hoisted_2 = { class: "flex flex-col gap-y-6 justify-between w-3/5" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-x-2 gap-y-6 w-full items-end" }
const _hoisted_4 = {
  class: "flex items-center rounded-md border border-gray-lp-400 relative text-black-lp-100 text-sm mt-1",
  style: {"height":"2.435rem"}
}
const _hoisted_5 = {
  class: "flex items-center rounded-md border border-gray-lp-400 relative text-black-lp-100 text-sm mt-1",
  style: {"height":"2.435rem"}
}
const _hoisted_6 = { class: "col-span-2 grid grid-cols-2 gap-x-2 w-full" }
const _hoisted_7 = { class: "flex items-center gap-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_DatePickerV2 = _resolveComponent("DatePickerV2")!
  const _component_MultipleSelectSearchVirtualScroll = _resolveComponent("MultipleSelectSearchVirtualScroll")!
  const _component_DropdownMultiSelect = _resolveComponent("DropdownMultiSelect")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.visible = $event)),
    title: _ctx.$t('cargo.filters.createCargoList'),
    persistent: "",
    customBody: "p-0",
    customWidth: "w-3/5",
    showOverflow: true
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_TimeRangePicker, {
          startDate: _ctx.form.periodeStart,
          endDate: _ctx.form.periodeEnd,
          maxDate: new Date(),
          onSelect: _ctx.setPeriode,
          default: "custom",
          "only-panel": "",
          class: "w-2/5",
          "custom-class": "items-start",
          ref: "dateRangeFilter"
        }, null, 8, ["startDate", "endDate", "maxDate", "onSelect"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('cargo.labels.bookingStartDate')
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_Icons, {
                    name: "calendar",
                    class: "w-4 text-gray-lp-600 absolute left-2 transform top-1/2 -translate-y-1/2",
                    fill: ""
                  }),
                  _createVNode("input", {
                    type: "text",
                    value: _ctx.periodeStartFormatted,
                    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlurPeriodeStart && _ctx.onBlurPeriodeStart(...args))),
                    placeholder: _ctx.$t('cargo.placeholders.selectStartDate'),
                    class: "h-full flex items-center border-l border-gray-lp-400 ml-8 px-2 w-full rounded-r-md outline-none"
                  }, null, 40, ["value", "placeholder"])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DatePickerV2, {
              modelValueTime: _ctx.periodeStartTime,
              placeholder: "00:00",
              onSelectedTime: _ctx.inputDateStartTime,
              onBlur: _ctx.onValidateTime,
              showDatePicker: false,
              showTimePicker: "",
              customClass: "mb-0",
              customClassTime: "w-full",
              maxDate: new Date(new Date().setDate(new Date().getDate() + 1)),
              locale: _ctx.accountCountryCode
            }, null, 8, ["modelValueTime", "onSelectedTime", "onBlur", "maxDate", "locale"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('cargo.labels.bookingEndDate')
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Icons, {
                    name: "calendar",
                    class: "w-4 text-gray-lp-600 absolute left-2 transform top-1/2 -translate-y-1/2",
                    fill: ""
                  }),
                  _createVNode("input", {
                    type: "text",
                    value: _ctx.periodeEndFormatted,
                    onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBlurPeriodeEnd && _ctx.onBlurPeriodeEnd(...args))),
                    placeholder: _ctx.$t('cargo.placeholders.selectEndDate'),
                    class: "h-full flex items-center border-l border-gray-lp-400 ml-8 px-2 w-full rounded-r-md outline-none"
                  }, null, 40, ["value", "placeholder"])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DatePickerV2, {
              modelValueTime: _ctx.periodeEndTime,
              placeholder: "00:00",
              onSelectedTime: _ctx.inputDateEndTime,
              onBlur: _ctx.onValidateTime,
              showDatePicker: false,
              showTimePicker: "",
              customClass: "mb-0",
              customClassTime: "w-full",
              maxDate: new Date(new Date().setDate(new Date().getDate() + 1)),
              locale: _ctx.accountCountryCode
            }, null, 8, ["modelValueTime", "onSelectedTime", "onBlur", "maxDate", "locale"]),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('cargo.labels.hubLocation'),
                optional: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MultipleSelectSearchVirtualScroll, {
                    options: _ctx.hubList,
                    modelValue: _ctx.form.selectedHub,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.selectedHub = $event)),
                    keyName: "name",
                    keyValue: "code",
                    selectAllText: _ctx.$t('cargo.v2.filter.selectAll'),
                    selectAllClass: "font-normal",
                    placeholder: _ctx.$t('cargo.placeholders.selectHubLocation'),
                    "show-select-all": true,
                    "max-displayed-chips": 2,
                    allEnabled: "",
                    selectAllOption: "",
                    onFocus: _cache[4] || (_cache[4] = () => _ctx.onFilterHub('')),
                    onFilter: _ctx.onFilterHub,
                    onChange: _ctx.onChangeHub,
                    class: "mt-1"
                  }, null, 8, ["options", "modelValue", "selectAllText", "placeholder", "onFilter", "onChange"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('cargo.labels.destinationCity'),
                optional: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MultipleSelectSearchVirtualScroll, {
                    options: _ctx.cityDestinationData,
                    modelValue: _ctx.form.destinationCity,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.destinationCity = $event)),
                    keyName: "name",
                    keyValue: "code",
                    selectAllText: _ctx.$t('cargo.v2.filter.selectAll'),
                    selectAllClass: "font-normal",
                    placeholder: _ctx.$t('cargo.placeholders.selectDestinationCity'),
                    "show-select-all": true,
                    "max-displayed-chips": 2,
                    allEnabled: "",
                    selectAllOption: "",
                    onFocus: _ctx.fetchCityDestination,
                    onFilter: _ctx.onFilterCityDestination,
                    class: "mt-1"
                  }, null, 8, ["options", "modelValue", "selectAllText", "placeholder", "onFocus", "onFilter"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('cargo.labels.bookingUser'),
                optional: "",
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MultipleSelectSearchVirtualScroll, {
                    options: _ctx.createdByList,
                    modelValue: _ctx.form.createdBy,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.createdBy = $event)),
                    keyName: "name",
                    keyValue: "code",
                    selectAllText: _ctx.$t('cargo.v2.filter.selectAll'),
                    selectAllClass: "font-normal",
                    placeholder: _ctx.$t('cargo.placeholders.selectBookingUser'),
                    "show-select-all": true,
                    "max-displayed-chips": 2,
                    allEnabled: "",
                    selectAllOption: "",
                    onFocus: _ctx.fetchCreatedBy,
                    onFilter: _ctx.onFilterCreatedBy,
                    class: "mt-1"
                  }, null, 8, ["options", "modelValue", "selectAllText", "placeholder", "onFocus", "onFilter"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('cargo.v2.filter.moda'),
                optional: "",
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DropdownMultiSelect, {
                    modelValue: _ctx.form.cargoTypes,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.cargoTypes = $event)),
                    options: _ctx.modaOptions,
                    placeholder: _ctx.$t('cargo.v2.filter.selectModa'),
                    class: "mt-1"
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_LpButton, {
              color: "white",
              textColor: "red-lp-100",
              customClass: "border border-red-lp-100",
              title: _ctx.$t('cargo.actions.cancel'),
              "is-width-full": "",
              outline: "",
              onClick: _ctx.onClose
            }, null, 8, ["title", "onClick"]),
            _createVNode(_component_LpButton, {
              color: "red-lp-100",
              textColor: "white",
              title: _ctx.$t('cargo.actions.save'),
              "is-width-full": "",
              onClick: _ctx.onDownload,
              disabled: _ctx.disabled
            }, null, 8, ["title", "onClick", "disabled"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}